import { CONFIG } from "./config";

// 1단지의 transformSrcPoint와 동일한 변환 (x,y 스왑)
const swapXY = (pt) => ({ x: pt.y, y: pt.x });

export const SITES = [
  {
    value: "1",
    label: "래미안 원페를라 1단지",
    deviceId: "one_perla_omron_ld90_01",
    robotName: "1단지 물류로봇",
    robotImage: "/assets/omron.png",
    mapImage: "/assets/map.png",
    perspectiveMapping: CONFIG.PERSPECTIVE_MAPPING,
    mapOriginalSize: CONFIG.MAP_ORIGINAL_SIZE,
    poiList: CONFIG.POI_LIST,
    headingOffset: 0,
  },
  {
    value: "2",
    label: "래미안 원페를라 2단지",
    deviceId: "one_perla_kuka_02",
    robotName: "2단지 물류로봇",
    robotImage: "/assets/KMP-250P-02.png",
    mapImage: "/assets/map02.png",
    perspectiveMapping: {
      srcPts: [
        { x: 10016, y: 85795 }, // 좌상 (raw 로봇 좌표)
        { x: 84330, y: 85795 }, // 우상
        { x: 10016, y: 27394 }, // 좌하
        { x: 84330, y: 27394 }, // 우하
      ].map(swapXY),
      dstPts: [
        { x: 660, y: 145 }, // 좌상
        { x: 1860, y: 160 }, // 우상
        { x: 666, y: 1366 }, // 좌하
        { x: 1855, y: 1372 }, // 우하
      ],
    },
    mapOriginalSize: { width: 2507, height: 1771 },
    poiList: [
      { poiId: "201dong", name: "201동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "202dong", name: "202동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "203dong", name: "203동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "204dong", name: "204동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "200base", name: "시작위치로 이동", command: "COMMAND_MOVE" },
      { poiId: "200charge", name: "충전위치로 이동", command: "COMMAND_MOVE" },
      { poiId: "201dong", name: "201에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "202dong", name: "202에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "203dong", name: "203에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "204dong", name: "204에서 언도킹", command: "COMMAND_UNDOCK" },
      {
        poiId: "200base",
        name: "시작위치에서 언도킹",
        command: "COMMAND_UNDOCK",
      },
      {
        poiId: "200charge",
        name: "충전위치에서 언도킹",
        command: "COMMAND_UNDOCK",
      },
      { poiId: null, name: "도킹", command: "COMMAND_DOCK" },
    ],
    headingOffset: 90,
  },
  {
    value: "3",
    label: "래미안 원페를라 3단지",
    deviceId: "one_perla_kuka_03",
    robotName: "3단지 물류로봇",
    robotImage: "/assets/KMP-250P-02.png",
    mapImage: "/assets/map03.png",
    perspectiveMapping: {
      srcPts: [
        { x: 104218, y: 95258 },
        { x: 104218, y: 18558 },
        { x: 13818, y: 95258 },
        { x: 13818, y: 18558 },
      ].map(swapXY),
      dstPts: [
        { x: 560, y: 154 },
        { x: 1756, y: 166 },
        { x: 484, y: 1576 },
        { x: 1753, y: 1603 },
      ],
    },
    mapOriginalSize: { width: 2464, height: 1728 },
    poiList: [
      { poiId: "301dong", name: "301동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "302dong", name: "302동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "303dong", name: "303동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "304dong", name: "304동으로 이동", command: "COMMAND_MOVE" },
      { poiId: "300base", name: "시작위치로 이동", command: "COMMAND_MOVE" },
      { poiId: "300charge", name: "충전위치로 이동", command: "COMMAND_MOVE" },
      { poiId: "301dong", name: "301에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "302dong", name: "302에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "303dong", name: "303에서 언도킹", command: "COMMAND_UNDOCK" },
      { poiId: "304dong", name: "304에서 언도킹", command: "COMMAND_UNDOCK" },
      {
        poiId: "300base",
        name: "시작위치에서 언도킹",
        command: "COMMAND_UNDOCK",
      },
      {
        poiId: "300charge",
        name: "충전위치에서 언도킹",
        command: "COMMAND_UNDOCK",
      },
      { poiId: null, name: "도킹", command: "COMMAND_DOCK" },
    ],
    headingOffset: 0,
  },
];
